import React from 'react'
import "./NailSalonTestimonial.css"
import NailSalonTestimonialHead from './NailSalonTestimonialHead'
import NailSalonTestimonialMain from './NailSalonTestimonialMain'
const NailSalonTestimonial = () => {
  return (
    <div className='nailTestimonialContainer'>
      <NailSalonTestimonialHead/>
      <NailSalonTestimonialMain/>
    </div>
  )
}

export default NailSalonTestimonial
